













































































































































































































import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import AppLoading from '@/components/ui/AppLoading.vue'
import ListaDeLojas from '@/components/usuario/ListaDeLojas.vue'
import RevealPasswordField from '@/components/ui/RevealPasswordField.vue'
import CampoDeTelefone from '@/components/ui/CampoDeTelefone.vue'
import {
	SaveUsuarioUseCase,
	FindUsuarioUseCase,
	FindLojaUseCase,
	FindPerfilUseCase,
	FindTabelaDePrecoUseCase,
} from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { UsuariosModule } from '@/store/vuex/usuario/UsuariosStore'
import { Loja, PontoDeVendaDoUsuario, TabelaDePreco, Usuario } from '@/models'
import SelecaoDePerfil from '@/components/perfil/SelecaoDePerfil.vue'
import EdicaoGenerica from '@/components/layout/EdicaoGenerica.vue'
import { obrigatorio, naoPermiteEmail } from '@/shareds/regras-de-form'
import ListaDeLojasEPdvs from '@/components/usuario/ListaDeLojasEPdvs.vue'
import ListaDeGruposEconomicos from '@/components/usuario/ListaDeGruposEconomicos.vue'
import SeletorDeTabelaDePreco from '@/components/tabeladepreco/SeletorDeTabelaDePreco.vue'
import { nextTick } from '@/shareds/utils'
import CampoDeCpf from '@/components/ui/CampoDeCpf.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import {
	criarUsuario,
	cpfEhObrigatorioParaUsuario,
	campoDeCpfEstaBloqueado,
	validarCamposObrigatoriosDoVendedor,
} from '@/shareds/usuario-shareds'

@Component({
	components: {
		AppLoading,
		ListaDeLojas,
		RevealPasswordField,
		SelecaoDePerfil,
		EdicaoGenerica,
		ListaDeLojasEPdvs,
		CampoDeCpf,
		CampoDeTelefone,
		ListaDeGruposEconomicos,
		SeletorDeTabelaDePreco,
	},
})
export default class EdicaoDeUsuario extends Vue {
	@Ref() form1!: HTMLFormElement
	@Ref() edicaoGenerica!: EdicaoGenerica<Usuario>
	@Prop({ type: Boolean }) novo!: boolean
	@Prop({ type: String }) id!: string
	@Ref() camposDeTelefones!: CampoDeTelefone[]

	obrigatorio = obrigatorio
	naoPermiteEmail = naoPermiteEmail
	cpfEhObrigatorioParaUsuario = cpfEhObrigatorioParaUsuario
	campoDeCpfEstaBloqueado = campoDeCpfEstaBloqueado
	erro: null | Error = null
	usuario: Usuario | null = null
	versaoAnterior: Usuario | null = null
	carregando = true
	salvando = false
	cpfCadastradoAoCarregar = false


	saveUsuarioUseCase = new SaveUsuarioUseCase()
	findUsuarioUseCase = new FindUsuarioUseCase()
	findLojaUseCase = new FindLojaUseCase()
	findPerfilUseCase = new FindPerfilUseCase()
	findTabelaDePrecoUseCase = new FindTabelaDePrecoUseCase()
	lojas: Loja[] = []
	pdvs: PontoDeVendaDoUsuario[] = []
	tabelaDePreco: TabelaDePreco | null = null

	@Watch('id', { immediate: true })
	onChangeId() {
		this.carregar()
	}

	get permiteInativarFuncionarios() {
		return UserLoginStore.permiteRegraDeNegocio('pode-inativar-funcionario')
	}

	async carregar() {

		try {
			this.carregando = true
			this.lojas = []
			this.pdvs = []
			const usuario = this.novo
				? criarUsuario()
				: await this.findUsuarioUseCase.findById(this.id)
			if (!usuario.telefones) usuario.telefones = []
			this.lojas = usuario.lojas
			this.pdvs = usuario.pdvs
			this.usuario = usuario
			this.cpfCadastradoAoCarregar = !!usuario.cpf
			this.tabelaDePreco = usuario.tabelaDePrecoId
				? await this.findTabelaDePrecoUseCase.get(usuario.tabelaDePrecoId)
				: null
			nextTick().then(() => {
				this.versaoAnterior = JSON.parse(JSON.stringify(this.usuario))
			})
			UsuariosModule.setUsuarioSelecionado(this.usuario)
		} catch (error: any) {
			this.erro = error
			AlertModule.setError(error)
		} finally {
			this.$nextTick(() => {
				this.carregando = false
			})
		}
	}

	adicionarTelefone() {
		if (!this.usuario) return
		this.usuario.telefones.push('')
		this.$nextTick(() => {
			if (!this.usuario) return
			const campo = this.camposDeTelefones[this.usuario.telefones.length - 1]
			campo.$children[0].focus()
		})
	}

	criarUsuario(): Usuario {
		return {
			id: '',
			email: null,
			nome: '',
			login: '',
			cpf: null,
			ativo: true,
			perfil: {
				id: '',
				nome: '',
				permissoes: [],
				gruposEconomicos: [],
				percentualMaximoDesconto: 0,
				tempoParaLogoff: '',
				percentualMaximoDescontoPorItem: 0,
				tempoLimiteDeInatividade: '',
				telaInicial: '',
				limiteCustoMensalIA: 0,
				perfilInterno: false,
			},
			tags: [],
			lojas: [],
			avatar: '',
			senha: '',
			pdvs: [],
			telefones: [],
			vendedor: false,
			criaFaq: false,
			gruposEconomicos: [],
			autoLoginAoAbrirCaixa: false,
			codigoExterno: '',
			isPrimeiroAcesso: false,
			representante: false,
			usuarioTecnico: false,
		}
	}

	async salvar() {
		if (!this.usuario) return
		if (!this.form1.validate()) return
		if (this.usuario.gruposEconomicos.length === 0) {
			AlertModule.setError('Informe ao menos um grupo econômico')
			return
		}
		
		const erroDoVendedor = validarCamposObrigatoriosDoVendedor(this.usuario, this.novo)
		if (erroDoVendedor) {
			AlertModule.setError(erroDoVendedor)
			return
		}

		try {
			this.salvando = true
			const usuario: Usuario = {
				...this.usuario,
				senha: !this.usuario.senha ? '' : this.usuario.senha,
				lojas: [...this.lojas],
				pdvs: !this.pdvs ? [] : [...this.pdvs],
				cpf: this.usuario.cpf || null,
				email: this.usuario.email || null,
				vendedor: this.usuario.vendedor || false,
				criaFaq: this.usuario.criaFaq || false,
				gruposEconomicos: this.usuario.gruposEconomicos,
				autoLoginAoAbrirCaixa: this.usuario.autoLoginAoAbrirCaixa || false,
				codigoExterno: this.usuario.codigoExterno || undefined,
				tabelaDePrecoId: this.tabelaDePreco ? this.tabelaDePreco.id : null,
			}
			const usuarioSalvo = await this.saveUsuarioUseCase.save(usuario)
			this.id
				? UsuariosModule.atualizaUsuario(usuarioSalvo)
				: UsuariosModule.adicionaUsuario(usuarioSalvo)

			this.cpfCadastradoAoCarregar = !!usuarioSalvo.cpf
			AlertModule.setSuccess('Usuário salvo com sucesso!')
			if (this.novo) {
				this.$router.push({
					name: 'Usuário',
					params: { id: usuarioSalvo.id },
				})
			}
			this.versaoAnterior = JSON.parse(JSON.stringify(this.usuario))
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	get getMessageError() {
		return AlertModule.getErrorMsg
	}
	
	async beforeRouteUpdate(to,from,next){
		next(!await this.edicaoGenerica.validarTransicao())
	}

	async beforeRouteLeave(to, from, next){
		if(!this.salvando){
			next(!await this.edicaoGenerica.validarTransicao())
		}else {
			next()
		}
	}

	@Watch('usuario.ativo', { immediate: true })
	onChangeUsuarioAtivo(ativo: boolean) {
		if (this.usuario && !ativo) {
			this.usuario.autoLoginAoAbrirCaixa = false
		}
	}

	@Watch('usuario.nome')
	onChangeNome(nome: string) {
		if (!this.novo || !this.usuario?.vendedor) return
		this.usuario.login = this.gerarLoginSugerido(nome, this.usuario.cpf)
	}

	@Watch('usuario.cpf')
	onChangeCpf(cpf: string | null) {
		if (!this.novo || !this.usuario?.vendedor) return
		this.usuario.login = this.gerarLoginSugerido(this.usuario.nome, cpf)
	}

	@Watch('usuario.vendedor')
	onChangeVendedor(vendedor: boolean) {
		if (!this.novo || !this.usuario) return
		if (vendedor) {
			this.usuario.login = this.gerarLoginSugerido(this.usuario.nome, this.usuario.cpf)
			this.usuario.senha = this.gerarSenhaForte()
		} else {
			this.usuario.login = ''
			this.usuario.senha = ''
		}
	}

	gerarLoginSugerido(nome: string, cpf?: string | null): string {
		const partes = nome
			.normalize('NFD')
			.replace(/[̀-ͯ]/g, '')
			.toLowerCase()
			.trim()
			.split(/\s+/)
			.filter(p => p.length > 0)
		const base = partes.length === 0
			? ''
			: partes.length === 1
				? partes[0]
				: `${partes[0]}.${partes[1][0]}`
		if (!base) return ''
		
		const sufixoCpf = (cpf || '').replace(/\D/g, '').slice(0, 5)
		return sufixoCpf ? `${base}${sufixoCpf}` : base
	}

	gerarSenhaForte(): string {
		const maiusculas = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
		const minusculas = 'abcdefghijklmnopqrstuvwxyz'
		const numeros = '0123456789'
		const especiais = '@#$%&*!'
		const todos = maiusculas + minusculas + numeros + especiais
		const rand = (str: string) => str[Math.floor(Math.random() * str.length)]
		const base = [rand(maiusculas), rand(minusculas), rand(numeros), rand(especiais)]
		for (let i = 0; i < 6; i++) base.push(rand(todos))
		return base.sort(() => Math.random() - 0.5).join('')
	}
}
